export default function ({ navigator }) {
  return <div className='min-h-screen flex items-center justify-center'>
    404
  </div>
}
